import React from "react";
import { CSpinner } from "@coreui/react";

/**
 * Props for CSpinnerText. Inherits all CSpinner props, plus:
 * - text: string (required) — text to display next to the spinner
 * - gap?: "1" | "2" | "3" (default: "1") — Bootstrap margin-end gap between spinner and text
 * - textClassName?: string — class for the text span
 */
export type CSpinnerTextProps = React.ComponentProps<typeof CSpinner> & {
  text: string;
  gap?: "1" | "2" | "3";
  textClassName?: string;
};

/**
 * A wrapper component that renders a CSpinner with adjacent text.
 */
export const CSpinnerText: React.FC<CSpinnerTextProps> = ({
  text,
  gap = "1",
  textClassName,
  className,
  size = "sm",
  ...spinnerProps
}) => {
  return (
    <span className={className}>
      <CSpinner size={size} className={`me-${gap}`} {...spinnerProps} />
      <span className={textClassName}>{text}</span>
    </span>
  );
};
